import React from 'react';
import { cn } from '@/utils/cn';
interface Props {
  children: React.ReactNode;
  name: string;
  defaultChecked?: boolean;
  value: string;
  onClick?: (value: string) => void;
  disabled?: boolean;
  className?: string;
  size: 'large' | 'medium';
  onChange?: () => void;
}
export function Radio({
  children,
  name,
  defaultChecked,
  value,
  onClick,
  disabled,
  className,
  size,
  onChange
}: Props) {
  const handleClick = () => onClick && onClick(value);
  const handleChange = () => onChange && onChange();
  return <label className={cn('flex w-fit gap-2', {
    'text-text-mediumGray': disabled
  }, {
    'cursor-pointer': !disabled
  }, className)} onClick={handleClick} data-sentry-component="Radio" data-sentry-source-file="radio.tsx">
            <div className={cn('relative flex shrink-0 items-center justify-center', {
      'h-6 w-6 p-px': size === 'large',
      'h-4.5 w-4.5': size !== 'large'
    })}>
                <input type='radio' name={name} value={value} disabled={disabled} className={cn('peer z-10 h-full w-full appearance-none rounded-full border-2 border-text-mediumGray transition-all checked:border-primary-main enabled:cursor-pointer enabled:checked:!border-primary-main enabled:hover:border-text-darkGray disabled:border-text-lightGray disabled:checked:border-primary-shade-200 lg:enabled:checked:hover:!border-primary-shade-400')} defaultChecked={defaultChecked} onChange={handleChange} />
                <div className={cn('absolute hidden cursor-pointer rounded-full bg-primary-main transition-all peer-checked:flex peer-disabled:bg-primary-shade-200 lg:peer-enabled:peer-hover:peer-checked:bg-primary-shade-400', {
        'h-3.5 w-3.5': size === 'large',
        'h-2.5 w-2.5': size !== 'large'
      })} />
            </div>
            {children}
        </label>;
}